import { Toast } from 'vant';
import { message } from 'ant-design-vue';

/** 验证密码 */
export function pwdValidate (rule, value, callback) {
  console.log('pwdValidate: ', value);
  if (typeof value === 'string') {
    value = value.toString();
  }
  const arr = value.split('');
  const numReg = /^\d$/;
  const wordReg = /^[a-zA-Z]$/;
  const chinaWord = /^[\u4e00-\u9fa5]$/;
  const allNum = arr.every(item => numReg.test(item));
  const allWord = arr.every(item => wordReg.test(item));
  const hasChinaWord = arr.some(item => chinaWord.test(item));

  if (!value) {
    const msg = '请输入密码';
    callback ? callback(new Error(msg)) : message.error(msg);
  } else if (value.length < 6 || value.length > 32) {
    const msg = '长度为6-32位';
    callback ? callback(new Error(msg)) : message.error(msg);
  } else if (allNum) {
    const msg = '不能为纯数字';
    callback ? callback(new Error(msg)) : message.error(msg);
  } else if (allWord) {
    const msg = '不能为纯字母';
    callback ? callback(new Error(msg)) : message.error(msg);
  } else if (hasChinaWord) {
    const msg = '不能为汉字';
    callback ? callback(new Error(msg)) : message.error(msg);
  } else {
    if (callback) {
      callback();
    } else {
      return true;
    }
  }
}
